var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReviewsCategoriesTableContainer',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"customColumn",fn:function(ref){
var item = ref.item;
var columnName = ref.columnName;
return [_c('ReviewsCategoriesColorScaleTableColumn',{attrs:{"value":item[columnName],"item":item,"colors":_vm.colors,"column-name":columnName,"is-comparison-enabled":_vm.isComparing}})]}}])},'ReviewsCategoriesTableContainer',_vm.tableContainerAttrs,false),_vm.tableContainerEvents))}
var staticRenderFns = []

export { render, staticRenderFns }